import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';
import { textBold } from 'styles';
import { breakpoint } from 'utils/mediaQueries';
import BlockSocial from 'components/header/preheader/social';

const StyledGrid = styled(Grid)`
  text-align: ${props => props.textalignement};
  padding: 1rem;
  flex: 0 0 auto;
  p {
    margin: 0;
  }
  ${breakpoint.down('md')`
  text-align: center; align-items: center`}
`;
const Title = styled(Markdown)`
  font-family: ${props => `${props.theme.typography.h1.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.h6.fontSize}px`};
  line-height: 2rem;
  ${textBold}
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};`}
`;
const SubTitle = styled(Markdown)`
  padding-top: 0.2rem;
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
  line-height: 2rem;
  ${textBold}
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};`}
`;
const Text = styled(Markdown)`
  flex: 0 0 auto;
  width: 100%;
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
  line-height: 2rem;
  ${breakpoint.down('md')`
  line-height: 1.6rem;
  font-size: ${props => `${props.theme.typography.body2.fontSize}px`};`};
  p {
    padding-top: 1rem;
  }
  strong {
    font-family: ${props => `${props.theme.typography.fontFamily}`};
    font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
    line-height: 2rem;
    ${textBold}
    ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};`}
  }
`;
const SocialGrid = styled(Grid)`
  padding-top: 2rem;
  flex: 0 0 auto;
  img {
    max-height: 1.5rem;
  }
  ${breakpoint.down('md')`
  padding-top: 1rem;`}
`;
const StoryBlock = ({ data }) => {
  if (data.frontmatter.component === 'story') {
    return (
      <StyledGrid container direction={'column'} textalignement="right">
        <Title>{data.frontmatter.title}</Title>
        <SubTitle>{data.frontmatter.subTitle}</SubTitle>
        <Text>{data.rawMarkdownBody}</Text>
      </StyledGrid>
    );
  } else {
    return (
      <StyledGrid
        container
        direction={'column'}
        textalignement="left"
        wrap={'nowrap'}
      >
        <Title>{data.frontmatter.title}</Title>
        <Text>{data.rawMarkdownBody}</Text>
        <SocialGrid container item xs={8} sm={8} md={8} lg={8}>
          <BlockSocial color={'purple'} />
        </SocialGrid>
      </StyledGrid>
    );
  }
};
export default StoryBlock;
